import { useParams, Link } from 'react-router';
import { getProjectBySlug } from '../../lib/projects.js';
import { getDisciplineBySlug } from '../../lib/disciplines.js';
import { formatDate } from '../../lib/dateUtils.js';
import { useDocumentTitle } from '../../lib/useDocumentTitle.js';

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = getProjectBySlug(slug);
  useDocumentTitle(project ? project.title : 'Project Not Found');

  if (!project) {
    return (
      <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
        <h1>Project not found</h1>
        <p>
          <Link to="/projects">Back to projects</Link>
        </p>
      </div>
    );
  }

  const discipline = getDisciplineBySlug(project.discipline);

  return (
    <div className="container" style={{ paddingTop: '3rem', paddingBottom: '3rem', maxWidth: '68ch' }}>
      <p className="meta">
        <Link to="/projects">← Projects</Link>
      </p>
      <h1>{project.title}</h1>
      <p className="meta">
        {discipline?.shortName || project.discipline} · {project.status} · started{' '}
        {formatDate(project.startDate)}
      </p>
      <p>{project.description}</p>

      {project.contributors?.length > 0 && (
        <p>
          <strong>Contributors:</strong> {project.contributors.join(', ')}
        </p>
      )}

      <p>
        {project.repoUrl && (
          <a href={project.repoUrl} target="_blank" rel="noreferrer">
            Repository
          </a>
        )}
        {project.repoUrl && project.liveUrl && ' · '}
        {project.liveUrl && (
          <a href={project.liveUrl} target="_blank" rel="noreferrer">
            Live
          </a>
        )}
      </p>

      {project.tags?.length > 0 && <p className="meta">{project.tags.join(', ')}</p>}
    </div>
  );
}
